module.exports = __webpack_public_path__ + "app-demo.svg";